import { useState, MouseEvent } from "react";
import { useForm, Controller } from "react-hook-form";
import adminClasses from "../../../landing-pages/admin/admin.module.css";
import RegisteredCompaniesRequestModel from "../../../../models/admin/company/request/RegisteredCompaniesRequestModel";
import toasterUtils from "../../../../utils/toaster-utils";
import { Button, Checkbox, FormControl, FormControlLabel, TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";

interface CompanyConfigurationProps {
    objCompany: RegisteredCompaniesRequestModel;
    onCloseCompanyConfiguration: () => void;
    onCompanyConfigurationSave: (objCompany: RegisteredCompaniesRequestModel) => void;
};

const CompanyConfigurationComponent = (props: CompanyConfigurationProps) => {

    const {
        register,
        control,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm<RegisteredCompaniesRequestModel>({
        mode: "onChange",
        defaultValues: {
            ...props.objCompany,
            startDate: props.objCompany.startDate
                ? (dayjs(props.objCompany.startDate) as any)
                : null,
            endDate: props.objCompany.endDate
                ? (dayjs(props.objCompany.endDate) as any)
                : null,
        },
    });

    const onSubmit = (formData: RegisteredCompaniesRequestModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        props.onCompanyConfigurationSave(formData);
    }

    return (
        <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.noOfInterviewsAllowed}>
                        <TextField label="No Of Interviews Allowed" type="number" size="small"
                            {...register("noOfInterviewsAllowed")} error={!!errors.noOfInterviewsAllowed} helperText={errors.noOfInterviewsAllowed?.message} autoComplete="off" required />
                    </FormControl>
                </div>
                <div className="col-md-6">
                    <Controller name="isAuthorize" control={control} defaultValue={false}
                        render={({ field }) => (
                            <FormControl margin="normal">
                                <FormControlLabel
                                    control={
                                        <Checkbox {...field} checked={field.value} onChange={(e) => field.onChange(e.target.checked)} color="primary" size="small" />
                                    }
                                    label="Authorize"
                                />
                            </FormControl>
                        )}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Controller name="startDate" control={control} rules={{ required: "Start date is required" }}
                            render={({ field, fieldState }) => (
                                <FormControl fullWidth margin="normal" error={!!fieldState.error}>
                                    <DatePicker
                                        label="Start Date"
                                        value={field.value}
                                        onChange={field.onChange}
                                        format="DD-MMM-YYYY"
                                        slotProps={{
                                            textField: {
                                                size: "small",
                                                fullWidth: true,
                                                error: !!fieldState.error,
                                                helperText: fieldState.error?.message,
                                                onKeyDown: (e) => e.preventDefault(),
                                            },
                                        }}
                                    />
                                </FormControl>
                            )}
                        />
                    </LocalizationProvider>
                </div>
                <div className="col-md-6">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Controller name="endDate" control={control} rules={{ required: "Start date is required" }}
                            render={({ field, fieldState }) => (
                                <FormControl fullWidth margin="normal" error={!!fieldState.error}>
                                    <DatePicker
                                        label="End Date"
                                        value={field.value}
                                        onChange={field.onChange}
                                        format="DD-MMM-YYYY"
                                        slotProps={{
                                            textField: {
                                                size: "small",
                                                fullWidth: true,
                                                error: !!fieldState.error,
                                                helperText: fieldState.error?.message,
                                                onKeyDown: (e) => e.preventDefault(),
                                            },
                                        }}
                                    />
                                </FormControl>
                            )}
                        />
                    </LocalizationProvider>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6"></div>
                <div className="col-md-6">
                    <Button variant="contained" color="success" type="submit" disabled={!isValid}>
                        Save
                    </Button>
                    <Button variant="contained" color="error" className="m-l-xxs" type="button" onClick={props.onCloseCompanyConfiguration}>
                        Close
                    </Button>
                </div>
            </div>
        </form>
    );
};
export default CompanyConfigurationComponent;